import { useMemo } from 'react';
import type { AppliedFilters } from '~/contracts/common';
import useGetVehicles from '~/hooks/home/services/useGetVehicles';
import useGetMostViewedOrMostRecentYMM from './useGetMostViewedOrMostRecentYMM';

export default function useGetBudgetFriendlyVehicles() {
  const { make, price, parentModel } = useGetMostViewedOrMostRecentYMM() ?? {};
  const { total = 0 } = price || {};
  const filters = useMemo<Partial<AppliedFilters>>(
    () =>
      make && parentModel
        ? {
            makes: [{ name: make, parentModels: [{ name: parentModel }] }],
            price: { max: Math.floor(total * 0.9) }
          }
        : {},
    [make, parentModel, total]
  );

  return useGetVehicles(
    filters,
    Boolean(make && parentModel),
    'Budget Friendly Vehicles'
  );
}
